/* global gtag, yaCounterNUMBERID */
// import scrollDepth from 'scroll-depth';

function start15SecTimeout() {
	let timer;

	clearTimeout(timer);

	timer = setTimeout(() => {
		gtag('event', 'time_on_page_15s');
	}, 5000);
}

/**
* Создать куки запись
* @param {string} path Обязательное, ссылка/путь
*/
function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		// Не всегда используются
		// ga('rbcspec.set', 'page', path);
		// ga('rbcspec.send', 'pageview', path);
	}

	// NUMBERID нужно менять для каждого проекта, так же используется в PUG
	if (window.yaCounterNUMBERID) {
		yaCounterNUMBERID.hit(path);
	}
}

function init() {
	start15SecTimeout();

	// scrollDepth({
	// 	userTiming: false,
	// 	pixelDepth: false,
	// 	gtmOverride: true,
	// 	eventHandler(data) {
	// 		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	// 		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	// 	},
	// });

	document.querySelectorAll('.js-header-client-link').forEach((el) => {
		el.addEventListener('click', () => {
			gtag('event', 'client_link', {
				event_category: 'navigation',
				event_label: 'logo header',
			});
		});
	});

	document.querySelectorAll('.js-header-link').forEach((el) => {
		el.addEventListener('click', () => {
			gtag('event', 'logo_click');
		});
	});

	// links in block info
	document.querySelectorAll('.info-block__content a').forEach((el) => {
		el.addEventListener('click', (e) => {
			gtag('event', 'client_link', {
				event_category: 'popup',
				event_label: e.currentTarget.textContent,
			});
		});
	});

	// final client link
	document.querySelector('.js-final-link').addEventListener('click', () => {
		gtag('event', 'client_link', {
			event_category: 'test final link',
		});
	});
}

export default {
	start15SecTimeout,
	virtualHit,
	init,
};
